var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"sku-header"},[_vm._v(_vm._s(_vm.props.name)+" "+_vm._s(_vm.props.skuFormat))])}
var staticRenderFns = []

export { render, staticRenderFns }